/**
 * [阻止事件的冒泡和浏览器的默认事件]
 *
 * @export
 * @param {event} e
 */
export function preventDefault(e: any) {
  try {
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
  } catch (error) {
    console.log(error);
  }
}
